import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var UploadIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsxs(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M11.488.204a.744.744 0 0 1 1.024 0l7.5 7.074c.303.285.319.765.036 1.07a.744.744 0 0 1-1.06.038L12.75 2.502v13.414a.754.754 0 0 1-.75.758.754.754 0 0 1-.75-.758V2.502L5.012 8.386a.745.745 0 0 1-1.06-.037.764.764 0 0 1 .036-1.071l7.5-7.074Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M1.5 15.158a.754.754 0 0 0-.75-.758c-.414 0-.75.34-.75.758V19.2C0 21.851 2.127 24 4.75 24h14.5c2.623 0 4.75-2.149 4.75-4.8v-4.042a.754.754 0 0 0-.75-.758c-.414 0-.75.34-.75.758V19.2c0 1.814-1.455 3.284-3.25 3.284H4.75c-1.795 0-3.25-1.47-3.25-3.284v-4.042Z"
            })
        ]
    }));
};
